export function cursorToEnd(el: HTMLInputElement) {
  el.setSelectionRange(-1, -1)
}
